/* eslint-disable import/no-extraneous-dependencies */
import {
  Module, Mutation, VuexModule,
} from 'vuex-module-decorators';

@Module({
  namespaced: true,
  name: 'auth',
})
export default class extends VuexModule {
  token: string | null = null;

  @Mutation
  public setToken(token: string) {
    this.token = token;
  }
}
